import React from 'react';

const BOND_SCHEMES = {
  NSW: {
    name: 'Rentstart Bond Loan',
    provider: 'Homes NSW',
    url: 'https://onlineforms.homes.nsw.gov.au/register/RBL/',
    terms: 'Full bond covered · Interest-free · Online application · 12–18 month repayment',
  },
  VIC: {
    name: 'RentAssist Bond Loan',
    provider: 'Housing Victoria',
    url: 'https://www.housing.vic.gov.au/apply-rentassist-bond-loan',
    terms: 'Bond covered · Interest-free · Apply via myGov',
  },
  QLD: {
    name: 'Bond Loan Plus',
    provider: 'Dept of Housing',
    url: 'https://blarga.hpw.qld.gov.au/',
    terms: 'Bond + 2 weeks advance · Interest-free · Fee-free',
  },
  WA: {
    name: 'Bond Assistance Loan',
    provider: 'Dept of Housing & Works',
    url: 'https://www.wa.gov.au/organisation/department-of-housing-and-works/housing-options-bond-assistance-loans',
    terms: 'Bond + 2 weeks advance · Interest-free · Repayments via Centrelink · Max $1,600 single',
  },
  SA: {
    name: 'Private Rental Assistance',
    provider: 'SA Housing Trust',
    url: 'https://www.housing.sa.gov.au/about/policies/private-rental-assistance-program-policy',
    terms: 'Up to 4 weeks rent assistance · Free',
  },
  TAS: {
    name: 'Interest-Free Bond Loan',
    provider: 'Housing Tasmania',
    url: 'https://www.housing.tas.gov.au',
    terms: 'Bond covered · Interest-free',
  },
  NT: {
    name: 'Private Rental Bond Assistance Loan',
    provider: 'Dept of Housing',
    url: 'https://dhlgcd.nt.gov.au/funding-and-support/private-rental-bond-assistance-loan',
    terms: 'Bond covered · Interest-free',
  },
  ACT: null, // No free scheme available
};

const BondLoanTab = ({ currentUser }) => {
  // Detect state from user profile/application
  const userState = currentUser?.state ||
    currentUser?.application_data?.state ||
    currentUser?.preferred_location?.split(',').pop()?.trim()?.toUpperCase() ||
    null;

  const scheme = userState ? BOND_SCHEMES[userState] : null;
  const stateLabel = userState || 'your state';

  return (
    <div className="tab-content" data-testid="bond-loan-tab">
      <div style={{ maxWidth: 720, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ background: '#1a2332', borderRadius: 12, padding: '24px 28px', marginBottom: 24, color: 'white' }}>
          <h2 style={{ margin: '0 0 8px', fontSize: 22 }}>Free Government Bond Loan</h2>
          <p style={{ margin: 0, color: 'rgba(255,255,255,0.8)', fontSize: 14 }}>
            Your state government offers a free, interest-free bond loan for eligible renters. As an HSS member, you are pre-qualified.
          </p>
        </div>

        {/* Upfront cost breakdown */}
        <div style={{ background: '#fef9ec', border: '1px solid #fcd34d', borderRadius: 10, padding: '16px 20px', marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 12px', color: '#92400e', fontSize: 16 }}>Typical HSS Upfront Costs</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <tbody>
              {[
                ['Bond share (4 weeks)', 'e.g. $1,000/wk ÷ 4 tenants × 4 weeks', '~$1,000'],
                ['Rent in advance (2 weeks)', '$250/wk × 2 weeks', '~$500'],
                ['HSS membership fee', '', '$230'],
              ].map(([item, calc, amt]) => (
                <tr key={item} style={{ borderBottom: '1px solid #fde68a' }}>
                  <td style={{ padding: '6px 8px', fontWeight: 600, color: '#1a2332' }}>{item}</td>
                  <td style={{ padding: '6px 8px', color: '#6b7280', fontSize: 13 }}>{calc}</td>
                  <td style={{ padding: '6px 8px', fontWeight: 700, textAlign: 'right' }}>{amt}</td>
                </tr>
              ))}
              <tr style={{ background: '#fef3c7' }}>
                <td colSpan={2} style={{ padding: '8px', fontWeight: 800, color: '#1a2332' }}>Total upfront</td>
                <td style={{ padding: '8px', fontWeight: 900, textAlign: 'right', color: '#dc2626' }}>~$1,730</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* State-specific scheme */}
        {userState && scheme ? (
          <div style={{ background: '#f0fdf4', border: '2px solid #86efac', borderRadius: 12, padding: '20px 24px', marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#059669', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 }}>{userState} Government Scheme</div>
                <h3 style={{ margin: '0 0 4px', color: '#1a2332', fontSize: 18 }}>{scheme.name}</h3>
                <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 8 }}>{scheme.provider}</div>
                <div style={{ fontSize: 13, color: '#059669', fontWeight: 600 }}>{scheme.terms}</div>
              </div>
              <a href={scheme.url} target="_blank" rel="noopener noreferrer"
                style={{ display: 'inline-block', padding: '12px 24px', background: '#059669', color: 'white', borderRadius: 8, fontWeight: 700, fontSize: 15, textDecoration: 'none', whiteSpace: 'nowrap' }}
                data-testid="bond-loan-apply-btn">
                Apply for your free bond loan →
              </a>
            </div>
          </div>
        ) : userState === 'ACT' ? (
          <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '16px 20px', marginBottom: 20 }}>
            <h3 style={{ margin: '0 0 8px', color: '#dc2626' }}>ACT — No Free Government Scheme</h3>
            <p style={{ margin: '0 0 12px', color: '#4b5563', fontSize: 14 }}>Unfortunately no free government bond loan scheme currently operates in the ACT. If upfront costs are a barrier, please contact HSS support.</p>
            <a href="mailto:members@housesharingseniors.com.au" style={{ color: '#2563eb', fontWeight: 600 }}>Contact HSS Support →</a>
          </div>
        ) : (
          <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, padding: '16px 20px', marginBottom: 20 }}>
            <p style={{ margin: '0 0 8px', color: '#1d4ed8', fontWeight: 600 }}>All States &amp; Territories (except ACT)</p>
            <p style={{ margin: 0, color: '#4b5563', fontSize: 14 }}>Free government bond loan schemes exist in every state. Select your state below to see your scheme.</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 10, marginTop: 16 }}>
              {Object.entries(BOND_SCHEMES).filter(([, s]) => s).map(([state, s]) => (
                <div key={state} style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 8, padding: '12px 14px' }}>
                  <div style={{ fontWeight: 700, color: '#1a2332', marginBottom: 4 }}>{state} — {s.name}</div>
                  <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>{s.terms}</div>
                  <a href={s.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 13, color: '#2563eb', fontWeight: 600 }}>Apply →</a>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Eligibility */}
        <div style={{ background: '#f8fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: '16px 20px', marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 12px', color: '#1a2332', fontSize: 16 }}>Why You Are Pre-Qualified</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {[
              'Australian citizen or permanent resident',
              'Low income — Age Pension qualifies in every state',
              'Minimal cash assets (typically under $5,000 required)',
              'Not a property owner',
              'Rent below 50% of income — HSS members pay ~30%',
            ].map(item => (
              <div key={item} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#374151' }}>
                <span style={{ color: '#059669', fontWeight: 700, fontSize: 16 }}>✓</span>
                {item}
              </div>
            ))}
          </div>
        </div>

        <p style={{ fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>
          This is a government scheme operated independently of HSS. HSS does not provide financial products or advice.
        </p>
      </div>
    </div>
  );
};

export default BondLoanTab;
